import PageShell, { PageHeader, Prose } from "@/components/PageShell";
import Seo from "@/components/Seo";

const PrivacyPage = () => (
  <PageShell>
    <Seo title="Privacy Policy — Nema TV" description="How Nema TV collects, uses and protects your personal information." path="/privacy" />
    <PageHeader eyebrow="Legal" title="Privacy Policy" subtitle="Last updated: January 2026" />
    <Prose>
      <p>
        This Privacy Policy explains how Nema TV (&quot;we&quot;, &quot;us&quot;) collects, uses and shares
        information about you when you use nematv.com or the Nema TV streaming apps.
      </p>

      <h2>Information we collect</h2>
      <ul>
        <li>Account details (name, email, plan) that you provide when you subscribe.</li>
        <li>Payment details, which are processed by our payment provider — we never store your card.</li>
        <li>Usage data (device type, IP address, streaming logs) to keep the service reliable.</li>
      </ul>

      <h2>How we use information</h2>
      <ul>
        <li>Deliver the service and honour your subscription.</li>
        <li>Send transactional emails (receipts, service notices).</li>
        <li>With your consent, send marketing updates you can opt out of at any time.</li>
      </ul>

      <h2>Sharing</h2>
      <p>
        We do not sell personal information. We share limited data with vetted processors
        (payments, email delivery, analytics) strictly to operate Nema TV.
      </p>

      <h2>Your rights</h2>
      <p>
        You can request access, correction or deletion of your data at any time by writing
        to <a href="mailto:privacy@nematv.com">privacy@nematv.com</a>. Newsletter subscribers can also
        unsubscribe from any email using the link in the footer.
      </p>

      <h2>Contact</h2>
      <p>Questions about privacy? <a href="mailto:privacy@nematv.com">privacy@nematv.com</a></p>
    </Prose>
  </PageShell>
);

export default PrivacyPage;
